import { render, staticRenderFns } from "./FreeInfographicImage.vue?vue&type=template&id=3e7a5cbf&"
import script from "./FreeInfographicImage.vue?vue&type=script&lang=js&"
export * from "./FreeInfographicImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
